import { useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import { initialValues } from './initialValuesLI'
import ReactSelect from '../../../../../components/ReactSelect/ReactSelect'
import Input from '../../../../../components/_shared/Input/Input'
import styles from './styles.module.css'
import MyDateField from '../../../../../components/_shared/MyDateTimeField/MyDateField'
import validationSchema from './validationSchema'
import Button from '../../../../../components/_shared/Button/Button'
import { useLocation } from 'react-router-dom'
import IncidentUserAsyncDropdown from './IncidentUserAsyncDropdown'
import IncidentDeviceAsyncDropdown from './IncidentDeviceAsyncDropdown'


const IncidentModalForm = ({
    show,
    setIsOpen,
    isLoading,
    handlefilteredData,
    setClearBtn,
    filteredData,
    refStatusOption,
    showNoUser,
}) => {
    const location = useLocation()
    const isMyIncidents = location.pathname.startsWith('/myincidents')
    const [deviceLabel, setDeviceLabel] = useState('')

    const handleFilteredField = (values) => {
        let filterObj = {}
        let clearBtn = false
        for (const key in values) {
            if (values[key] !== '' && values[key] !== undefined && values[key] !== null) {
                filterObj[key] = values[key]
                clearBtn = true
            }
        }
        handlefilteredData({
            ...filterObj,
            status: refStatusOption?.find(
                (ele) => ele?.value === values?.status
            )?.label,
            ...(filterObj.device_cd && deviceLabel ? { _deviceLabel: deviceLabel } : {}),
        })
        setClearBtn(clearBtn)
        setIsOpen(false)
    }


    return (
        <>
            <section className={`${styles.mainWrapper} mb-4`}>
                <div className="mt-4">
                    <Formik
                        enableReinitialize
                        initialValues={filteredData || initialValues}
                        validationSchema={validationSchema}
                        onSubmit={async (values, { setTouched }) => {
                                let obj;
                                Object.keys(values)?.forEach((key) => {
                                    if (values[key] !== '') {
                                        obj = { ...obj, [key]: values[key] };
                                    }
                                });
                                handleFilteredField(obj);
                                setTouched({});
                        }}
                    >
                        {({
                            values,
                            errors,
                            touched,
                            setFieldTouched,
                            setFieldError,
                            setFieldValue,
                        }) => (
                            <>
                                <div
                                    className={`${styles.mainWrapperInner} ${show && styles.active
                                        }`}
                                >
                                    <Form>
                                        <Row>
                                        <Col
                                                className="mb-3"
                                                xs={12}
                                                md={6}
                                            >
                                                <div>
                                                    <Field
                                                        name="incident_id"
                                                        type="number"
                                                        labelText=" Incident ID"
                                                        component={Input}
                                                    />
                                                     <ErrorMessage className='errormessage' name='incident_id' component={"div"} />
                                                </div>
                                            </Col>
                                                  <Col
                                                className="mb-3"
                                                xs={12}
                                                md={6}
                                            >
                                                <div>
                                                    <Field
                                                        name="incidentname_tx"
                                                        type="text"
                                                        labelText="Incident Name"
                                                        component={Input}
                                                    />
                                                </div>
                                            </Col>
                                              <Col className="mb-3" xs={12} md={6}>
                                                <div>
                                                    <Field
                                                        name="description_tx"
                                                        type="text"
                                                        labelText="Description"
                                                        component={Input}
                                                    />
                                                </div>
                                            </Col>
                                              <Col
                                                className="mb-3"
                                                xs={12}
                                                md={6}
                                            >
                                                <div>
                                                    <ReactSelect
                                                        value={
                                                            refStatusOption?.find(
                                                                (item) =>
                                                                    item?.value ===
                                                                    values?.status
                                                            ) || ''
                                                        }
                                                        name="status"
                                                        labelText={`Status`}
                                                        isClearable={false}
                                                        options={
                                                            refStatusOption
                                                        }
                                                        setFieldValue={
                                                            setFieldValue
                                                        }
                                                        setFieldError={
                                                            setFieldError
                                                        }
                                                        setFieldTouched={
                                                            setFieldTouched
                                                        }
                                                        touched={touched}
                                                        errors={errors}
                                                        values={values}
                                                    />
                                                </div>
                                            </Col>
                                             {!isMyIncidents && (
                                                <Col
                                                    className="mb-3"
                                                    xs={12}
                                                    md={6}
                                                >
                                                    <div>
                                                        <IncidentUserAsyncDropdown
                                                            value={values?.user_name_tx}
                                                            setFieldValue={setFieldValue}
                                                            showNoUser={showNoUser}
                                                        />
                                                    </div>
                                                </Col>
                                            )}
                                             <Col
                                                className="mb-3"
                                                xs={12}
                                                md={6}
                                            >
                                                <div>
                                                    <IncidentDeviceAsyncDropdown
                                                        value={values?.device_cd}
                                                        setFieldValue={setFieldValue}
                                                        onLabelChange={setDeviceLabel}
                                                    />
                                                </div>
                                            </Col>
                                              <Col
                                                className="mb-3"
                                                xs={12}
                                                md={6}
                                            >
                                                <div>
                                                    <Field
                                                        name="startscore_nr"
                                                        type="number"
                                                        labelText="Score From"
                                                        component={Input}
                                                        min={-50000}
                                                    />
                                                    <ErrorMessage className='errormessage' name='startscore_nr' component={"div"} />
                                                </div>
                                            </Col>
                                            <Col
                                                className="mb-3"
                                                xs={12}
                                                md={6}
                                            >
                                                <div>
                                                    <Field
                                                        name="endscore_nr"
                                                        type="number"
                                                        labelText="Score To"
                                                        component={Input}
                                                        min={-50000}
                                                    />
                                                    <ErrorMessage className='errormessage' name='endscore_nr' component={"div"} />
                                                </div>
                                            </Col>
                                            <Col
                                                className="mb-3"
                                                xs={12}
                                                md={6}
                                            >
                                                <div>
                                                    <MyDateField
                                                        label={`Start Date`}
                                                        name="startincident_dt"
                                                        touched={touched}
                                                        errors={errors}
                                                    />
                                                    {/* Rendered from `errors` rather than <ErrorMessage>: MyDateField never
                                                        marks the field touched, so <ErrorMessage> would stay silent and the
                                                        Search click would look like it simply did nothing. */}
                                                    {errors?.startincident_dt && (
                                                        <div className="errormessage">
                                                            {errors.startincident_dt}
                                                        </div>
                                                    )}

                                                </div>
                                            </Col>
                                            <Col
                                                className="mb-3"
                                                xs={12}
                                                md={6}
                                            >
                                                <div>
                                                    <MyDateField
                                                        label={`End Date`}
                                                        name="endincident_dt"
                                                        touched={touched}
                                                        errors={errors}
                                                    />
                                                    <ErrorMessage className='errormessage' name='endincident_dt' component={"div"} />
                                                  
                                                </div>
                                            </Col>
                                    
                                        </Row>
                                        <Button
                                            type="submit"
                                            classes="btn btn-primary float-end mt-4"
                                            loading={isLoading}
                                        >
                                            Search
                                        </Button>
                                        <div style={{ clear: 'both' }}></div>
                                    </Form>
                                </div>
                            </>
                        )}
                    </Formik>
                </div>
            </section>
        </>
    )
}
export default IncidentModalForm
